const M = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMiAxN1YxOUgxM1YxN0gyMlpNMjIgMTNWMTVIM1YxM0gyMlpNMjIgOVYxMUgxMFY5SDIyWk0yMiA1VjdINVY1SDIyWiIvPgo8L3N2Zz4K";
export {
  M as default
};
//# sourceMappingURL=filter-2d5122b1.mjs.map
